import { render } from "./ResetPasswordRequestPage.vue?vue&type=template&id=98a57bac"
import script from "./ResetPasswordRequestPage.vue?vue&type=script&lang=js"
export * from "./ResetPasswordRequestPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__